import { createContext, use } from "react";

/** What a `Field` publishes so the manager and `ClearAll` can reason about it. */
interface RegisteredField {
  id: string;
  label: string;
  removable: boolean;
  hasValue: boolean;
}

interface FiltersState {
  fields: RegisteredField[];
  visibleFieldIds: string[];
}

interface FiltersActions {
  registerField: (field: RegisteredField) => () => void;
  showField: (id: string) => void;
  hideField: (id: string) => void;
}

// No `meta` third part: the row holds no ref or imperative handle for a
// sub-component to reach for, and an empty one would only be shape.
interface FiltersContextValue {
  state: FiltersState;
  actions: FiltersActions;
}

const FiltersContext = createContext<FiltersContextValue | null>(null);

function useFiltersContext() {
  const context = use(FiltersContext);
  if (!context) {
    throw new Error(
      "DataTableFilters sub-components must be rendered inside <DataTableFilters>"
    );
  }
  return context;
}

export { FiltersContext, useFiltersContext };
export type {
  FiltersActions,
  FiltersContextValue,
  FiltersState,
  RegisteredField,
};
